<template>
  <div class="steps">
    <div class="steps__step" :class="{
      'steps__step--last': n == items.length - 1,
      'steps__step--disabled': latestItem && item.position > latestItem.position
    }" :title="item.title" v-for="(item, n) in items" @click="clickEvent(item, n)">
      <div class="steps__shape">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="100" r="90" stroke="#B61311" stroke-width="22" :class="{ 'steps__circle--active': isActive(item, n) }" class="steps__circle" />
        </svg>
      </div>
      <div class="steps__line-container">
        <svg class="steps__line" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" v-if="n != items.length - 1">
          <line x1="0" y1="0" :x2="n == items.length - 1 ? '50%' : '100%'" y2="0" stroke="#B61311" stroke-width="4" />
        </svg>
        <div class="steps__description">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['items', 'activeItem', 'latestItem', 'clickEvent'],

    methods: {
      isActive(item, index) {
        if (this.activeItem.id) {
          return this.activeItem.id === item.id;
        }
        return index === 0;
      },
    },
  };
</script>
